export const cardsHomeUrl = '/cards';
